// Hook para inicialización única de autenticación
// Evita múltiples llamadas de accessToken y authenticate al cargar la página
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import AuthManager from 'services/authManager'
import AuthService from 'modules/Auth/services/auth'

// Singleton global para controlar inicialización
let globalInitialized = false
let globalInitializationPromise = null

export default function useAuthInitialization() {
	// Redux selector para obtener el userId y el isLogin
	const {
		session: { userId, isLogin }
	} = useSelector(state => state)
	// Ref para controlar si se ha inicializado
	const hasInitialized = useRef(false)

	useEffect(() => {
		// Solo inicializar una vez globalmente
		if (globalInitialized || hasInitialized.current) {
			return
		}

		// Solo si está logueado y no se ha inicializado globalmente
		if (AuthService.isLoggedIn(true) && isLogin && userId) {
			hasInitialized.current = true
			globalInitialized = true

			// Crear promesa de inicialización única global
			globalInitializationPromise = AuthManager.authenticateUser()
				.then(() => {
					return AuthManager.getUserInfo(userId)
				})
				.then(() => {
					// Marcar inicialización como completa para evitar llamadas adicionales
					AuthManager.markInitializationComplete()
				})
				.catch(() => {
					// Resetear estado global en caso de error
					globalInitialized = false
					hasInitialized.current = false
				})
		}

		// Cleanup al desmontar
		return () => {
			// No resetear hasInitialized aquí para mantener el estado global
		}
	}, [userId, isLogin])

	// Función para forzar reinicialización (útil para logout/login)
	const reinitialize = () => {
		hasInitialized.current = false
		globalInitialized = false
		globalInitializationPromise = null
		AuthManager.clearState()
	}

	return {
		reinitialize,
		isInitializing: globalInitialized && !!globalInitializationPromise
	}
}
